import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAppLoading = isLoading => ({
  type: actionTypes.SET_APP_LOADING,
  payload: isLoading
})
